import { CountBadge } from 'ui/menu/Styled';
import { Filter24 } from 'ui/icons/aurora/24px/Filter24';
import { BUTTON_SIZES, BUTTON_VARIANTS, Button } from 'ui/button';

const displayText = {
  trigger: 'Filters',
};

type FilterMenuTriggerButtonProps = {
  selectedFilterCount: number;
  onClick?: () => void;
  triggerText?: string;
};

export const FilterMenuTriggerButton = ({
  selectedFilterCount,
  onClick,
  triggerText = displayText.trigger,
}: FilterMenuTriggerButtonProps) => (
  <Button
    data-test="filters-trigger-button"
    onClick={onClick}
    size={BUTTON_SIZES.LARGE}
    variant={BUTTON_VARIANTS.SECONDARY}
  >
    <Filter24 />
    {triggerText}
    {selectedFilterCount > 0 && (
      <CountBadge data-test="filters-trigger-button-count-badge">{selectedFilterCount}</CountBadge>
    )}
  </Button>
);

export default FilterMenuTriggerButton;
